module.exports = __webpack_public_path__ + "static/media/play-button.6d843e92.png";